import { render, staticRenderFns } from "./ClearLayout.vue?vue&type=template&id=545ed612&scoped=true&"
import script from "./ClearLayout.vue?vue&type=script&lang=js&"
export * from "./ClearLayout.vue?vue&type=script&lang=js&"
import style0 from "./ClearLayout.vue?vue&type=style&index=0&id=545ed612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ed612",
  null
  
)

export default component.exports